var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDotsMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.8125C1.3125 4.8125 0.5625 5.58594 0.5625 6.5C0.5625 7.4375 1.3125 8.1875 2.25 8.1875C3.16406 8.1875 3.9375 7.4375 3.9375 6.5C3.9375 5.58594 3.16406 4.8125 2.25 4.8125ZM0.5625 2.375C0.5625 3.3125 1.3125 4.0625 2.25 4.0625C3.16406 4.0625 3.9375 3.3125 3.9375 2.375C3.9375 1.46094 3.16406 0.6875 2.25 0.6875C1.3125 0.6875 0.5625 1.46094 0.5625 2.375ZM0.5625 10.625C0.5625 11.5625 1.3125 12.3125 2.25 12.3125C3.16406 12.3125 3.9375 11.5625 3.9375 10.625C3.9375 9.71094 3.16406 8.9375 2.25 8.9375C1.3125 8.9375 0.5625 9.71094 0.5625 10.625Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDotsMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dotsMenu.aa9a4a02.svg";
export { ForwardRef as ReactComponent };